import React from 'react';
import {
  CurrencyInput,
  MemberFilter,
  OpportunityStageCategoryFilter,
  OpportunityStageFilter,
  OpportunityTypeFilter,
  PracticeFilter,
  YesNoFilter,
} from '~/components';
import OpportunityPipelineFilter from '~/components/filters/OpportunityPipelineFilter';
import OpportunityTagFilter from '~/components/filters/OpportunityTagFilter';
import { useFeatures } from '~/hooks';
import FiltersGroup from './FiltersGroup';
import ReportPeriodFilter from './ReportPeriodFilter';
import { useIntegrations } from '~/contexts';

function OpportunityFiltersGroup({ filters, onChange }) {
  const features = useFeatures();
  const integrations = useIntegrations();

  const salesforceEnabled = integrations?.salesforce;
  const hubspotEnabled = integrations?.hubspot;

  return (
    <FiltersGroup
      label="Opportunity Filters"
      filters={[
        filters.opportunityClosedPeriod,
        filters.opportunityPipelines,
        filters.opportunityStages,
        filters.opportunityStageCategories,
        filters.opportunitySalesforceSynced,
        filters.opportunityHubspotSynced,
        filters.opportunityTags,
        filters.opportunityTypes,
        filters.opportunityOwners,
        filters.opportunityPractices,
        filters.opportunityAmountGreaterThanOrEqual,
      ]}>
      {salesforceEnabled && (
        <YesNoFilter
          icon="filter"
          clearable
          placeholder="Salesforce Synced"
          value={filters.opportunitySalesforceSynced}
          onChange={({ target: { value } }) => onChange({ opportunitySalesforceSynced: value })}
        />
      )}

      {hubspotEnabled && (
        <YesNoFilter
          icon="filter"
          clearable
          placeholder="HubSpot Synced"
          value={filters.opportunityHubspotSynced}
          onChange={({ target: { value } }) => onChange({ opportunityHubspotSynced: value })}
        />
      )}

      <ReportPeriodFilter
        value={filters.opportunityClosedPeriod}
        placeholder="Expected Close Date Range"
        onChange={({ target: { value } }) => onChange({ opportunityClosedPeriod: value })}
      />

      <OpportunityPipelineFilter
        name="opportunityPipelines"
        value={filters.opportunityPipelines}
        placeholder={'Opportunity Pipeline'}
        onChange={({ target: { value } }) => onChange({ opportunityPipelines: value })}
      />

      <OpportunityStageCategoryFilter
        name="opportunityStageCategories"
        value={filters.opportunityStageCategories}
        onChange={({ target: { value } }) => onChange({ opportunityStageCategories: value })}
      />

      <OpportunityStageFilter
        name="opportunityStages"
        value={filters.opportunityStages}
        opportunityStageCategoryId={filters.opportunityStageCategories.map((status) => status.id)}
        onChange={({ target: { value } }) => onChange({ opportunityStages: value })}
      />

      <MemberFilter
        name="opportunityOwners"
        value={filters.opportunityOwners}
        onChange={({ target: { value } }) => onChange({ opportunityOwners: value })}
        placeholder="Opportunity Owner"
        materialAlwaysVisible
      />

      <OpportunityTagFilter
        name="opportunityTags"
        value={filters.opportunityTags}
        onChange={({ target: { value } }) => onChange({ opportunityTags: value })}
        placeholder="Opportunity Tags"
        materialAlwaysVisible
      />

      <OpportunityTypeFilter
        name="opportunityTypes"
        value={filters.opportunityTypes}
        onChange={({ target: { value } }) => onChange({ opportunityTypes: value })}
        placeholder="Opportunity Type"
        materialAlwaysVisible
      />

      <CurrencyInput
        name="opportunityAmountGreaterThanOrEqual"
        value={filters.opportunityAmountGreaterThanOrEqual}
        onChange={(value) => onChange({ opportunityAmountGreaterThanOrEqual: value })}
        placeholder="0"
        materialPlaceholder="Minimum Opportunity Amount"
        materialAlwaysVisible
      />

      {features.practices && (
        <PracticeFilter
          name="opportunityPractices"
          value={filters.opportunityPractices}
          onChange={({ target: { value } }) => onChange({ opportunityPractices: value })}
          placeholder="Opportunity Practice"
          materialAlwaysVisible
        />
      )}
    </FiltersGroup>
  );
}

export default OpportunityFiltersGroup;
